/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { PointsHandler } from 'C4';
import PropTypes from 'prop-types';
import { baseAppId } from 'settings';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DashboardSliderCard = ({ item, itemType, sliderType }) => {
  let url;
  if (itemType === 'Train Sessions') {
    url = `/main/rewards/dashboard/training/chapter/${item.chapterID}/0`;
  }
  const setPoints = async () => {
    const pointsHandler = new PointsHandler();
    await pointsHandler.init();
  };

  const imageURL = [`https://front.travpromobile.com/${baseAppId}`, item.chapterImagePro].join('/');

  return (
    <Link
      to={url}
      className="item"
      onClick={() => {
        setPoints();
      }}
      style={{
        backgroundImage: `url(${imageURL})`,
      }}
    >
      <div className="background-overlay">
        <p>{item.chapterTitle}</p>
        {sliderType === 'completed_items' && (
          <div className="checkmark">
            <FontAwesomeIcon icon={['fas', 'check']} />
          </div>
        )}
      </div>
    </Link>
  );
};

DashboardSliderCard.propTypes = {
  itemType: PropTypes.string.isRequired,
  sliderType: PropTypes.string.isRequired,
  item: PropTypes.shape({
    company_id: PropTypes.string,
    chapterTitle: PropTypes.string,
    icon: PropTypes.string,
    chapterID: PropTypes.string,
    chapterImage: PropTypes.string,
  }).isRequired,
};

export default DashboardSliderCard;
